<style>
    :root {
        --orange: #e16c24;
        --white: #fefefe;
    }
    header {
        align-items: flex-end;
        background: var(--orange);
        color: var(--white);
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        width: 100%;
        position: -webkit-sticky;
        position: sticky;
        top: 0;
        z-index: 10;
    }
    header > * {
        margin: 0 1rem;
    }
    header > h1 {
        flex-shrink: 0;
        padding: 1rem;
    }
    header > nav > ul{
        padding: 0;
    }
    header > nav > ul > * {
        cursor: pointer;
        display: inline-block;
        flex: 0 0 1;
        flex-shrink: 0;
        font-family: 'latolight';
        padding: .25rem;
    }
    header > nav > ul > *:hover {
        font-weight: bold;
        zoom: 1.1;
    }
    header > nav > ul > li > a {
        color: var(--white);
        text-decoration: none;
    }
</style>

<script>
    export let loggedIn = false;
</script>

<header>
    <h1>Feeling Clever?</h1>
    <nav>
        <ul>
            {#if loggedIn === true}
                <div class="nav"></div>
            {:else}
                <li class="nav-btn"><a href="mailto:jeffrey@cleverfox.es">Contact</a></li>
                <li class="nav-btn"><i class="fa fa-sign-in"></i> Log In</li>
                <li class="nav-btn"><i class="fa fa-pencil"></i> Sign Up</li>
            {/if}
        </ul>
    </nav>
</header>

